import axios from 'axios';
const source = 'ATSV2';
export const sendTalkToSalesEmail = () =>
  axios.get(`api/users/sendsubscriptionemail?source=${source}`);
